import React from 'react';
import NumbersSale from '../components/Numbers/Numbers';
import HeaderSection from '../components/HeaderSection/HeaderSection';
import Footer from '../components/Footer/Footer';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';

function SellNumbers() {
  return (
    <>
      <HeaderSection
        title="Buy Premium Mobile Numbers"
        description="Choose from Sri Lanka’s top service providers and get your VIP number today!"
      />
      <NumbersSale />
      <WhatsAppButton />
      <Footer />
    </>
  );
}

export default SellNumbers;
